<template>
	<menu-wrapper
		:title="title"
		:user-data="userData"
		:main-menu-items="mainMenuItems"
		:profile-route="profileRoute"
		:add-logout="addLogout"
		:side-menu-items="sideMenuItems"
		:is-simulating="isSimulating"
	/>
</template>

<script>
import {
	RouteTranslator,
} from '../../mixins';

export default {
	mixins: [RouteTranslator, ],
	props: {
		userData: {
			type: Object,
			required: true,
		},
		mainMenuItems: {
			type: Array,
			required: true,
		},
		isSimulating: {
			type: Boolean,
			default: false,
		}
	},

	data () {
		return {
			sideMenuItems: [
				{
					title: this.$gettext('Reseller Portal'),
					onClick: this.redirect('/resellers'),
				},
				{
					title: this.$gettext('My policies'),
					onClick: this.redirect('/dashboard/policies'),
				},
				{
					title: this.$gettext('My invoices'),
					onClick: this.redirect('/dashboard/invoices'),
				},
				{
					title: this.$gettext('My claims'),
					onClick: this.redirect('/dashboard/claims'),
				},
				{
					title: this.$gettext('Communication history'),
					onClick: this.redirect('/dashboard/communication'),
				},
				{
					title: this.$gettext('Sign off'),
					onClick: this.redirect('/login/doLogout'),
				},
			],
			addLogout: false,
			title: 'BackOffice',
			profileRoute: `/bo/users/view?id=${this.$userId}`,
		};
	},
	methods: {
		/**
		 * Returns a function which redirects the window location
		 *
		 * @param {string} path - the path to redirect to
		 * @returns {Function} - a function which will modify the window location
		 */
		redirect (path) {
			return () => {
				this.translateRoute(path).then((translatedPath) => {
					window.location.href = translatedPath;
				});
			};
		},
	},
};
</script>
